import React, { useState, useEffect, useRef, useContext } from 'react';
import './Fakture.css';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { AuthContext } from '../../Header/auth - context';
import { useSelector, useDispatch } from 'react-redux';
import { badgeTekst, osveziUlazneBadge } from '../../custom/badgeFakture';
import NovaDevizna from './UlazneFakture/NovaDevizna';
import NovaDinarska from './UlazneFakture/NovaDinarska';
import PregledFaktura from './UlazneFakture/PregledFaktura';
import PregledUlaznih from './UlazneFakture/PregledUlaznih';
import PregledAvansa from './UlazneFakture/PregledAvansa';
import FaktureZaUnos from './UlazneFakture/FaktureZaUnos';
import TroskoviHome from './UlazneFakture/TroskoviHome';
import UlazniKOKZ from './UlazneFakture/UlazniKOKZ';

const Ulazne_fakture = () => {
  const { t } = useTranslation();
  const [changeView, setChangeView] = useState(1);
  /* SEF dokument izabran u „Fakture za unos" — nosi se u formu i tamo popunjava
     polja. Briše se čim forma javi da je fakturu snimila i povezala. */
  const [sefZaUnos, setSefZaUnos] = useState(null);
  /* Postojeća faktura otvorena iz pregleda — forma je učitava i zaključava po
     nivou izmene. Klik na „Nova …" je briše, pa se otvara prazna forma. */
  const [otvorena, setOtvorena] = useState(null);
  /* KO/KZ pokrenut sa fakture: { zaFakturu: { id_faktura, id_klijent } } ili { otvori: id } */
  const [kokzZa, setKokzZa] = useState(null);
  const otvoriKoKz = (x) => { setSefZaUnos(null); setKokzZa(x); setChangeView(7); };
  const otvoriFakturu = (r) => {
    setSefZaUnos(null);
    setOtvorena(r.ID);
    setChangeView(r.Devizna ? 2 : 1);
  };

  /* Valuta odlučuje koja se forma otvara: devizna faktura u dinarskoj formi
     nema gde da prikaže kurs. */
  const zapocniUnos = (dok) => {
    setOtvorena(null);
    setSefZaUnos(dok);
    /* Knjižno odobrenje / zaduženje sa SEF-a nije faktura — ide u KO / KZ. */
    if (/credit|debit|381|383/i.test(String(dok?.DocumentType || ''))) { setChangeView(7); return; }
    setChangeView(dok?.Currency && dok.Currency !== 'RSD' ? 2 : 1);
  };
  const activeClass = 'activeButton';
  const dispatch = useDispatch();
  const ulazneZaMene = useSelector((state) => state.ulazneZaMene || 0);
  const ulazneZaUnos = useSelector((state) => state.ulazneZaUnos || 0);
  const toast = useRef(null);
  const auth = useContext(AuthContext);
  const location = useLocation();
  const { idServis } = location.state || {};

  const handleErrors = (response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw response;
    }
  };

  useEffect(() => {
    if (!idServis) return;

    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + auth.token,
      },
      body: JSON.stringify({ tip: 'UL', id: idServis }),
    };

    fetch(process.env.REACT_APP_BACKEND_URL + '/invoice/GetInvoicesAndTypes', requestOptions)
      .then(handleErrors)
      .then((data) => {
        setChangeView(data?.isDinarska ? 1 : 2);
      })
      .catch((error) => {
        error.json?.().then((errorMessage) => {
          toast.current.show({
            severity: 'error',
            summary: 'Error',
            detail: errorMessage.message,
            life: 3000,
          });
        });
      });
  }, [idServis]);

  /* Posle odluke, dodele ili unosa brojevi se menjaju — osvežavaju se pri
     svakom prelasku na drugi podtab, da korisnik ne čeka 2 minuta. */
  useEffect(() => { osveziUlazneBadge(auth.token, dispatch); /* eslint-disable-next-line */ }, [changeView]);

  return (
    <div className="Ulazne_fakture">
      <Toast ref={toast} />
      {/* Traka sa karticama stoji odvojeno od forme — bez razmaka se akordeon
          lepi za dugmad pa deluje kao da je deo iste kontrole. */}
      <div className="ulazne-trakica-kartica">
        <Button id={changeView == 1 && activeClass} label={t('fakture.novaDinarska')} style={{ fontSize: 'smaller' }} className="mt-3 zaposleniShift" onClick={() => { setOtvorena(null); setChangeView(1); }} />
        <Button id={changeView == 2 && activeClass} label={t('fakture.novaDevizna')} style={{ fontSize: 'smaller' }} className="mt-3 zaposleniShift" onClick={() => { setOtvorena(null); setChangeView(2); }} />
        <Button id={changeView == 3 && activeClass} label={t('fakture.pregledFaktura')} style={{ fontSize: 'smaller' }} className="mt-3 zaposleniShift" onClick={() => { setChangeView(3); }} />
        <Button id={changeView == 4 && activeClass} label={t('nova.pregledAvansa')} style={{ fontSize: 'smaller' }} className="mt-3 zaposleniShift" onClick={() => { setChangeView(4); }} />
        <Button id={changeView == 7 && activeClass} label={t('ulazne.koKz')} style={{ fontSize: 'smaller' }} className="mt-3 zaposleniShift" onClick={() => { setSefZaUnos(null); setKokzZa(null); setChangeView(7); }} />
        {/* Badge na podtabu pokazuje TAČNO gde je ono što čeka — isti obrazac kao
            Provera faktura / Pregled predračuna na izlaznim. */}
        <div style={{ position: 'relative', display: 'inline-flex' }}>
          <Button id={changeView == 6 && activeClass} label={t('sefUlazne.proveraSef')} style={{ fontSize: 'smaller' }} className="mt-3 zaposleniShift" onClick={() => { setChangeView(6); }} />
          {ulazneZaMene > 0 && (
            <span className="sidebar-link-badge badge-blue" style={{ position: 'absolute', top: '-2px', right: '-6px', zIndex: 1 }}>
              {badgeTekst(ulazneZaMene)}
            </span>
          )}
        </div>
        <div style={{ position: 'relative', display: 'inline-flex' }}>
          <Button id={changeView == 5 && activeClass} label={t('sefUlazne.zaUnos')} style={{ fontSize: 'smaller' }} className="mt-3 zaposleniShift" onClick={() => { setChangeView(5); }} />
          {ulazneZaUnos > 0 && (
            <span className="sidebar-link-badge badge-blue" style={{ position: 'absolute', top: '-2px', right: '-6px', zIndex: 1 }}>
              {badgeTekst(ulazneZaUnos)}
            </span>
          )}
        </div>
        <Button id={changeView == 8 && activeClass} label={t('ulazne.podesavanjeTroskova')} style={{ fontSize: 'smaller' }} className="mt-3 zaposleniShift" onClick={() => { setChangeView(8); }} />
      </div>

      {changeView == 1 && <NovaDinarska key={'d' + (otvorena || 'n')} idFakture={otvorena} sefZaUnos={sefZaUnos} naUnesenu={() => setSefZaUnos(null)} naKoKz={otvoriKoKz} />}
      {changeView == 2 && <NovaDevizna key={'v' + (otvorena || 'n')} idFakture={otvorena} sefZaUnos={sefZaUnos} naUnesenu={() => setSefZaUnos(null)} naKoKz={otvoriKoKz} />}
      {/* 3 = zavedene ulazne fakture (knjiga), 6 = SEF sanduče (provera) */}
      {changeView == 3 && <PregledUlaznih naOtvori={otvoriFakturu} />}
      {changeView == 4 && <PregledAvansa />}
      {changeView == 6 && <PregledFaktura />}
      {changeView == 5 && <FaktureZaUnos naUnos={zapocniUnos} />}
      {/* vrste i podvrste troška sa podrazumevanim PDV-om (ranije Administracija → Troškovi) */}
      {changeView == 8 && <TroskoviHome />}
      {changeView == 7 && <UlazniKOKZ sefKokz={sefZaUnos} naUnesen={() => setSefZaUnos(null)} saFakture={kokzZa} />}
    </div>
  );
};
export default Ulazne_fakture;
